// @flow
import createAnalyticsSaga from '@rover/react-lib/redux/createAnalyticsSaga';

import { actions as creditCardActions } from '@rover/react-lib/redux/ducks/creditCards.duck';

import { selectors as conversationsCheckoutPageSelectors } from '../ConversationsCheckoutPage.duck';

const getData = (state: any, action: any) => {
  switch (action.type) {
    case creditCardActions.saveCreditCardSuccess.actionType:
      return {
        event: 'owner-conversion-checkout-save-card',
        serviceType: conversationsCheckoutPageSelectors.getServiceType(state),
      };
    default:
      return null;
  }
};

export default createAnalyticsSaga([creditCardActions.saveCreditCardSuccess.actionType], getData);



// WEBPACK FOOTER //
// ../react-lib/src/pages/conversations/ConversationsCheckoutPage/sagas/analytics.js